import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const TokenHistoryReducer = (state = {
    loading: false,
    shouldLoadMore: false,
    list: [],
}, { type, payload, }) => {
    switch (type) {
        case SteemActionType.INIT_TOKEN_HISTORY:
            return { loading: true, list: [], shouldLoadMore: false };
        case SteemActionType.LOAD_TOKEN_HISTORY:
            return {
                loading: false,
                list: payload === null || payload === void 0 ? void 0 : payload.transactions,
                shouldLoadMore: payload === null || payload === void 0 ? void 0 : payload.shouldLoadMore,
            };
        case SteemActionType.FETCH_MORE_TOKEN_HISTORY:
            return {
                loading: false,
                list: [...state.list, ...payload === null || payload === void 0 ? void 0 : payload.transactions],
                shouldLoadMore: payload === null || payload === void 0 ? void 0 : payload.shouldLoadMore,
            };
        case SteemActionType.IS_LOADING:
            return Object.assign(Object.assign({}, state), { loading: true });
        default:
            return state;
    }
};
export default TokenHistoryReducer;
